import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { createEntryApprovalRequest } from '../../api/api';
import { ADMINSTRATIVE_FEE, ENTRY_FEE, SEASON_ENTRY_FEE } from '../../utils/constants';
import { currentYear } from '../../utils/date';
import { PaymentOptions } from './PaymentOptions';

function SeasonSignupModal(props) {
    const [entryCount, setEntryCount] = useState(1);

    const handleSubmit = (event) => {
        event.preventDefault();
        const year = currentYear();
        createEntryApprovalRequest(year, entryCount * ENTRY_FEE, entryCount * ADMINSTRATIVE_FEE, `${year} season approval request`).then((user) => {
            props.setShow(false);
            props.setUser(user);
            toast.success("Approval request submitted.");
        });
    };

    return (
        <Modal show={props.show} onHide={() => props.setShow(false)}>
            <Modal.Header>
                <Modal.Title>Submit Entry Request</Modal.Title>
            </Modal.Header>

            <Form>
                <Modal.Body>
                    <p>To begin the season. You must submit an entry request</p>
                    <Form.Group className="mb-3" controlId="numberOfEntries">
                        <Form.Label>Number of Entries</Form.Label>
                        <Form.Select onChange={(e) => setEntryCount(e.target.value)}>
                            <option value="1">One</option>
                            <option value="2">Two</option>
                            <option value="3">Three</option>
                            <option value="4">Four</option>
                            <option value="5">Five</option>
                            <option value="6">Six</option>
                            <option value="7">Seven</option>
                            <option value="8">Eight</option>
                            <option value="9">Nine</option>
                            <option value="10">Ten</option>
                        </Form.Select>
                    </Form.Group>

                    <p>Submit <strong>${entryCount * (SEASON_ENTRY_FEE)}</strong> payment to Phil via:</p>
                    <PaymentOptions />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" type="submit" onClick={handleSubmit}>Request Approval</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default SeasonSignupModal;